import { selectLayoutsIds } from '../../selectors/layoutsCatalog';
import { useSelector } from 'react-redux';
import { ListingWrapper } from '../../components/ListingWrapper';
import { LayoutCard } from '../LayoutCard/';
import { PaginationContainer } from '../Pagination';
import { useDeviceType } from '@cian/ui-kit';
import { useMemo } from 'react';

export const Listing = () => {
  const ids = useSelector(selectLayoutsIds);

  const device = useDeviceType();

  const idsToShow = useMemo(() => (device === 'desktop' ? ids : ids.slice(0, 3)), [device, ids]);

  return (
    <ListingWrapper pagination={<PaginationContainer />}>
      {idsToShow.map(id => (
        <LayoutCard key={id} id={id} />
      ))}
    </ListingWrapper>
  );
};
